import { useState } from 'react';
import { FaEnvelope } from 'react-icons/fa';

export const ContactMe = () => {
    const [isCopied, setIsCopied] = useState(false);

    const email = "rahulprabhu200204@gmail.com";

    const copyToClipboard = () => {
        navigator.clipboard.writeText(email).then(() => {
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        });
    };

    return (
        <section id='contact' className="py-20 text-center overflow-x-hidden">
            <h2 className="text-3xl font-semibold text-white mb-4">Contact Me</h2>
            <div className="flex flex-col items-center space-y-4">
                <div className="flex items-center space-x-6">
                    <button
                        onClick={copyToClipboard}
                        className="bg-blue-500 text-black font-bold py-2 px-4 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        aria-label="Copy Email"
                    >
                        <FaEnvelope className="inline-block mr-2 bg-transparent" /> Copy Email
                    </button>
                    {isCopied && <p className="text-green-500">Email copied to clipboard!</p>}
                </div>
            </div>
        </section>
    );
};
